import Content from '../components/content/content';
import Footer from '../components/footer/footer';
import Sidemenu from '../components/sidemenu/sidemenu';
import NavBarTrigger from '../components/navbar-trigger/navbar-trigger';
import Navbar from '../components/navbar/navbar';
import AvatarMenu from '../components/avatar-menu/avatar-menu';
import BreadCrumb from '../components/breadcrumb/breadcrumb';
import PageTitle from '../components/page-title/page-title';
import InfoCard from '../components/info-card/info-card';
import Notification from '../components/notification/notification';

export { Content, Footer, Sidemenu, Navbar, NavBarTrigger, AvatarMenu, BreadCrumb, PageTitle, InfoCard, Notification };


// WEBPACK FOOTER //
// ./src/App/components/index.js